<template lang="pug">
v-container(fluid data-test="results-page")
  portal(to='toolbar') 
    v-toolbar-title CBR Availability
  
  v-card
    list(
      :dates="dates"
      :headers="headers"
      :list="list" 
      :cities="courseCities"
      :loading="loading"
      @importClicked="importAccounts"
    )
  
  //- v-btn( 
  //-   color="primary" fab @click="loadLogs" data-test="log-btn"
  //-   v-show="log"
  //- ).btn-floating
  //-   v-icon(color="white") mdi-post
  //- v-navigation-drawer(
  //-   v-model="logShowing"
  //-   fixed
  //-   right
  //-   width="400"
  //-   ref='drawer'
  //-   v-if="log"
  //- )
  //-   logs(:value="logShowing" @click:loadMore="loadLogsMore" :model="log" ref="log")
  //-     template(v-slot:candidateName="props")
  //-       span.link  {{ props.candidate.name }}
  //-       span.link  - {{ props.candidate.number }}, 
</template>

<script>
import {mapGetters, mapActions} from "vuex"

import { LOG_PAGE } from '@/util/const'
import errorsMixin from '@/mixins/errors.mixin'

import Svc from "./core/cbrAcc-service"
import CrmAccBroadcast from "./core/models/CbrAccBroadcast"
// import ResultsBroadcast from "./core/models/resultsExamBroadcast"
import CbrAccLogModel from "./core/models/CbrAccLogModel"
import api from "@/services/api/api-courses"
import CoursesSvc from "@/app/admin/models/courseService"
import { formattedDate } from '../../../../util/filters'

export default {
  mixins: [errorsMixin],

  data: () => ({
    svc: new Svc(),
    loading: false,
    list: [],
    dates: [],
    log: null,
    logShowing: false
    
  }),

  created() {
    this.init()
  },

  mounted() {
    this.loadData()
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/current',
      courseCities: 'crmCourseCities/items',
    }),

    headers() {
      let headers = [
        { text: 'Username', value: 'username', sortable: false, class:'text-center' },
        { text: 'Limit', value: 'limit', sortable: false, class: 'text-center'},
        { text: 'Free slots', value: 'free_slots', sortable: false, class: 'text-center'},
      ]
      let dates = this.dates.map(date => {
        let item = {
          text: formattedDate(date),
          value: date,
          sortble: false,
          class: 'text-center'
        }
        return item
      })
      return [...headers, ...dates]
    }
  },

  methods: {
    ...mapActions({
      loadCourseCities: 'crmCourseCities/list'
    }),
    init() {
    },

    async initLogs(wsURL) {
      let tokens
      tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.log = new CbrAccLogModel(
        {
          page: [LOG_PAGE.IMPORT_TOP_CBR]},
        `${wsURL}?auth_token=${tokens.access}`
      )
      this.log.ws.addEventListener("message", this.listenLogs)
    },

    listenLogs(msg) {
      this.log.listen(msg)
    },

    async loadData() {
      // await this.loadCities()
      Promise.all[this.loadList(), this.loadCities()]
    },

    async loadList() {
      try {
        this.loading = true
        let res = await this.svc.listAvaliability(this.$route.query)
        this.list = res.results
        this.dates = res.dates
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async loadCities() {
      try {
        await this.loadCourseCities()
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    loadLogs() {
      if(this.logShowing) {
        this.logShowing = false
        return
      }
      this.$refs.log.loadData({
        ...this.$refs.log.getDefaultPaginationParams(), 
        
      })
      this.logShowing = true
    },

    loadLogsMore() {
      this.$refs.log.loadMore({
        ...this.$refs.log.getPaginationParams(),
      })
    },

    async importAccounts(activeItems) {
      try {
        let ids = activeItems.map(item => item.ID)
        await this.svc.importAccounts(ids)
        this.$notify({text: 'Import started', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    }
  },

  watch: {
    currentUser: {
      handler: function(newUserData) {
        if(newUserData && newUserData.logsWebsocketPath) this.initLogs(newUserData.logsWebsocketPath)
      },
      immediate: true
    }
  },

  provide: function() {
    return {
      svc: this.svc
    }
  },

  components: {
    list: () => import('./components/CbrAvaliabilityList.vue'),
    logs: () => import('@/app/admin/components/Log.vue')
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/_placeholder.scss";
@import "@/assets/scss/_table_spread";
</style>
